<template>
  <Dialog
    @close="onCloseClick"
    :hideCloseBtn="props.showCloseBtn != true"
    :visible="props.visible"
    :title="props.title"
    :height="props.height"
    :width="props.width"
    titleAlign="center"
    background="rgba(53, 53, 76,0.8)"
    :customClass="`${props.customClass} action-dialog ${
      props.confirmConer ? 'action-dialog-coner' : ''
    } ${
      props.showCloseBtn ? 'action-dialog-close' : ''
    }`"
    :tag="props.tag"
  >
    <div class="action-dialog-wraper">
      <p
        class="action-dialog-text"
        :style="{
          textAlign: props.titleAlign,
        }"
      >
        <template
          v-for="(item, index) in props.content.split('\n')"
          :key="index"
        >
          <p>
            {{ item }}
          </p>
        </template>
      </p>
      <div
        class="action-dialog-btns flex"
        :class="{
          nocancel: props.hideCancel,
          'btn-layout-verical': props.btnLayoutVerical,
        }"
      >
        <div
          class="action-dialog-btn action-dialog-cancel flex1"
          v-if="!props.hideCancel"
        >
          <Button
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '44px',
              '--borderRadius': '50px',
              '--background': 'rgba(255, 255, 255, 0.1)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
              '--fontColorHover': '#fff',
              ...props.cancelRenderStyle,
            }"
            @click="onCancelClick"
            >{{ props.cancelLabel ?? $$t("create.cancel") }}</Button
          >
        </div>
        <div class="action-dialog-btn-margin" v-if="!props.hideCancel"></div>
        <div class="action-dialog-btn action-dialog-confirm flex1">
          <Button
            :renderStyle="{
              '--padding': '0',
              '--width': '100%',
              '--height': '44px',
              '--borderRadius': '50px',
              '--background': 'rgba(148, 173, 255, 1)',
              '--fontColor': '#000',
              '--fontSize': '14px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover': 'rgba(148, 173, 255, 0.8)',
              '--fontColorHover': '#000',
              ...props.confirmRenderStyle,
            }"
            @click="onConfirmClick"
          >
            <div class="action-dialog-confirm-content">
              {{ props.confirmLabel ?? $$t("create.confirm") }}
              <div
                class="action-dialog-confirm-coner"
                v-if="props.confirmConer"
              >
                {{ props.confirmConer }}
              </div>
            </div>
          </Button>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { reactive, ref, defineProps } from "vue";
import Dialog from "@/components/basic/dialog/Dialog.vue";
import Button from "@/components/basic/button/Button.vue";
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const props = defineProps({
  tag: String,
  confirmConer: {
    type: String,
    default: null, // subscribe
  },
  maskClose: {
    type: Boolean,
    default: false,
  },
  disableClose: {
    type: Boolean,
    default: false,
  },
  showCloseBtn: {
    type: Boolean,
  },
  hideCancel: {
    type: Boolean,
  },
  width: {
    type: String,
    default: "400px",
  },
  height: {
    type: String,
    default: "unset",
  },
  titleAlign: {
    type: String,
    default: "center",
  },
  title: String,
  subTitle: String,
  visible: {
    type: Boolean,
    default: false,
  },
  content: String,
  cancelLabel: String,
  confirmLabel: String,
  customClass: {
    type: String,
    default: "",
  },
  cancelRenderStyle: {
    type: Object,
    default: () => ({}),
  },
  confirmRenderStyle: {
    type: Object,
    default: () => ({}),
  },
  btnLayoutVerical: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["close", "confirm", "cancel"]);

const onCloseClick = () => {
  emits("close");
};

const onConfirmClick = () => {
  emits("confirm");
};

const onCancelClick = () => {
  emits("cancel");
};

onMounted(() => {});
</script>

<style lang="scss">
.action-dialog {
  > div.dialog-box {
    border-radius: 12px;
    padding: 40px 40px;
  }

  &.action-dialog-close {
    > div.dialog-box {
     padding: 90px 40px 40px 40px;
    }
  }
  .dialog-header {
    font-family: HarmonyOS Sans SC;
    font-size: 20px;
    font-weight: bold;
    line-height: 30px;
    margin-bottom: 12px;
    padding: 0 0 0 0;
  }
  .action-dialog-text {
    font-family: HarmonyOS Sans SC;
    font-size: 14px;
    font-weight: normal;
    line-height: 22px;
    color: #ffffff;
    p {
      min-height: 22px;
    }
  }
  .action-dialog-text.cn {
    font-weight: normal;
  }
  .action-dialog-btns {
    margin: 28px 0 0 0;
    height: 48px;
    display: flex;
    justify-content: center;
    &.btn-layout-verical{
      flex-direction: column;
      height: 100%;
      .action-dialog-btn {
        width: 100%;
        margin: 0 auto;
      }
      .action-dialog-btn-margin {
        width: 0;
        height: 12px;
      }
    }
  }

  .action-dialog-btn-margin {
    width: 12px;
  }
  .action-dialog-btn {
    height: 100%;
    width: 100%;
    flex: 1;
  }
  .action-dialog-btns.nocancel {
    .action-dialog-btn {
      width: 100%;
      margin: 0 auto;
    }
  }
  .action-dialog-confirm-content {
    position: relative;
    .action-dialog-confirm-coner {
      position: absolute;
      left: 100%;
      top: -12px;
      width: max-content;
      height: 22px;
      border-radius: 12px 20px 20px 0px;
      padding: 0 8px;
      background: linear-gradient(111deg, #ffe08b 0%, #fff7d0 47%, #ffe08b 99%);
      font-family: HarmonyOS Sans SC;
      font-size: 10px;
      font-weight: 500;
      line-height: 22px;
      color: #000000;
    }
  }
  &.action-dialog-coner {
    .dialog-content {
      overflow: unset;
    }
  }

  &.question-help-dialog {
    .action-dialog-text {
      p {
        margin: 22px 0 0 0;
        &:first-child {
          margin: 0;
        }
      }
    }
  }
}
</style>
